import * as React from 'react';
import { Input } from 'reactstrap';
import { EditState, ItemEditComponent } from '../itemEditComponent/ItemEditComponent';

export interface EditableInputProps {
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    editName: string;
    maxLength: number;
    error?: boolean;
    disabled: boolean;
    errorMessage?: string;
    name?: string;
    saveHandler: (a: string) => void;
    ValidationError?: boolean;
    vaildationMessage?: string;
    value: string;
}

export interface EditableInputState {
    value: string;
}

export default class EditableInput extends React.PureComponent<EditableInputProps, EditableInputState> {
    constructor(props: EditableInputProps) {
        super(props);
        this.state = {
            value: '',
        };
    }

    public componentWillReceiveProps() {
        this.setState({
            value: this.props.value,
        });
    }

    public render() {
        return (
            <ItemEditComponent
                name={this.props.name}
                disabled={this.props.disabled}
                editHandler={this.props.editHandler}
                saveHandler={() => {
                    this.props.saveHandler(this.state.value);
                }}
                cancelHandler={this.props.cancelHandler}
                content={this.renderContent(this.props.value)}
                contentEdit={this.renderContentEdit(this.props.value, this.props.maxLength)}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
                ValidationError={this.props.ValidationError}
                vaildationMessage={this.props.vaildationMessage}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === this.props.editName) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = (data: string) => {
        return <div>{data}</div>;
    };

    private renderContentEdit = (data: string, maxLength: number) => {
        return (
            <Input
                block="true"
                autoFocus={true}
                id={`EditableInput${data}`}
                name={`EditableInput${data}`}
                maxLength={maxLength}
                type="text"
                defaultValue={data}
                style={{ width: '70px' }}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.setState({ value: e.currentTarget.value })}
            />
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/editableInput/EditableInput.tsx